import React, { PureComponent, useEffect } from 'react';
import { Redirect, useParams } from "react-router-dom";
import { withRouter } from "react-router";
import { connect } from 'react-redux';
import { Typography, Grid } from '@mui/material/';

export default function Ebooks() {
  let { id } = useParams();
  useEffect(() => {
    window.location.href = process.env.REACT_APP_API_URL + '/file/ebook/' + id;
  },[]);

  return (
    <Grid
      container
      spacing={0}
      direction="column"
      alignItems="center"
      justifyContent="center"
      style={{ minHeight: '100vh' }}
    >
      <Typography align="center" variant="h2" gutterBottom={true}>
        Redirecting to download...
      </Typography>
    </Grid>
  );
}
